module.exports = __webpack_public_path__ + "static/35-07147a25ca7435b75ce97be2c3a14a12.png";